<template>
  <app-left-right>
    <template #left>
      <app-ad-keyword-tree
        ref="keywordTree"
        @select="selectRankGroup"
        @clear="clearRankData"
      ></app-ad-keyword-tree>
    </template>
    <template #right>
      <app-base-main parentTable no-padding>
        <template #filter-group>
          <app-filter-group @query="$gjNoticeQuery" @reset="$gjReset">
            <gj-select
              v-model="filter.trend"
              :options="KeywordRankEnum.trendOption"
              placeholder="排名趋势"
            ></gj-select>
            <gj-search-input
              v-model="filter.keyword"
              width="200px"
              placeholder="请输入关键词"
            ></gj-search-input>
            <gj-date-picker
              v-if="false"
              v-model="filter.date"
              tooltip="统计时间"
              type="daterange"
            ></gj-date-picker>
            <template #right>
              <gj-tool-group
                :download="$permission('keywordRank:export')"
                download-url="/ads/keywordRank/export"
                log @viewLog="viewLog"
                :download-params="globalParams"
                help
              ></gj-tool-group>
            </template>
          </app-filter-group>
        </template>
        <template #chart>
          <el-row :gutter="10">
            <el-col :span="12">
              <app-ad-keyword-rank-pie
                :loading="loading.pie"
                :data="data.pie"
              ></app-ad-keyword-rank-pie>
            </el-col>
            <el-col :span="12">
              <app-ad-keyword-rank-bar
                :loading="loading.bar"
                :data="data.bar"
              ></app-ad-keyword-rank-bar>
            </el-col>
          </el-row>
        </template>
        <template #table>
          <app-ad-keyword-rank-table
            adaptParent
            :loading="loading.table"
            :data="data.table"
            :pagination="pagination"
            @sort-change="$gjSortChange"
            @page-change="$gjNoticeQuery"
          ></app-ad-keyword-rank-table>
        </template>
      </app-base-main>
    </template>
  </app-left-right>
</template>

<script>
import {
  getAdKeywordRankPage,
  getAdsRankDistribution,
  getAdsRankDynamic,
} from "@/api/ad";
import { KeywordRankEnum } from "modules/common/ad/rank/keyword-rank/enum";
import AppAdKeywordRankBar from "modules/common/ad/rank/keyword-rank/charts/keyword-rank-bar";
import AppAdKeywordRankPie from "modules/common/ad/rank/keyword-rank/charts/keyword-rank-pie";
import AppAdKeywordRankTable from "modules/common/ad/rank/keyword-rank/keyword-rank-table";
import AppAdKeywordTree from "modules/ad/rank/keyword-rank/components/ad-keyword-tree";
import AdKeywrodLog from "modules/ad/rank/keyword-rank/components/ad-keywrod-log.vue"
import { queryMixin } from "@/minxins";
import { DATE_SHORTCUTS } from "@/utils/const";
import { defaultVal, isMeaningless } from "@/utils/common";

export default {
  name: "app-ad-keyword-rank",
  mixins: [queryMixin],
  components: {
    AppAdKeywordRankBar,
    AppAdKeywordRankPie,
    AppAdKeywordRankTable,
    AppAdKeywordTree,
  },
  data() {
    return {
      countryCode: null,
      asin: null,
      locationGroupId: null,
      filter: {
        trend: null,
        keyword: null,
        date: DATE_SHORTCUTS.last7Day.date,
      },
      KeywordRankEnum: KeywordRankEnum,
      loading: {
        table: false,
        pie: false,
        bar: false,
      },
      data: {
        table: [],
        pie: null,
        bar: null,
      },
      notStorage: true,
    };
  },
  methods: {
    // 操作日志
    viewLog() {
      this.$gjCreate(AdKeywrodLog, {
          props: {}
        })
    },
    selectRankGroup(data) {
      this.countryCode = data.countryCode;
      this.locationGroupId = data.locationGroupId;
      this.$gjNoticeQuery();
    },
    clearRankData() {
      // 设置空数据
      this.locationGroupId = null;
      this.data.table = [];
      this.data.pie = {
        downTrendKeywordQuantity: 0,
        monitorKeywordQuantity: 0,
        noTrendKeywordQuantity: 0,
        upTrendKeywordQuantity: 0,
      };
      this.data.bar = [
        { name: "首页", quantity: 0 },
        { name: "第2页", quantity: 0 },
        { name: "第3页", quantity: 0 },
        { name: "前三页无排名", quantity: 0 },
      ];
    },
    $gjQueryInitParams() {
      return {
        filter: {
          trend: null,
          keyword: null,
          date: DATE_SHORTCUTS.last7Day.date,
        },
      };
    },
    $gjQuery() {
      if (isMeaningless(this.locationGroupId)) {
        return;
      }
      // 构造查询参数
      const params = {
        model: {
          countryCode: this.countryCode,
          locationGroupId: this.locationGroupId,
          keyword: this.filter.keyword,
          trend: defaultVal(this.filter.trend, null),
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      // 保存全局参数
      this.globalParams = params;
      // 获取表格数据
      this.getTableData(params);
      // 获取饼图数据
      this.getPieData(params.model);
      // 获取柱状图数据
      this.getBarData(params.model);
    },
    getTableData(params) {
      // 查询
      this.loading.table = true;
      getAdKeywordRankPage(params)
        .then((data) => {
          this.data.table = data.records;
          this.pagination = this.getPagination(data);
        })
        .complete(() => (this.loading.table = false));
    },
    getPieData(params) {
      this.loading.pie = true;
      getAdsRankDynamic(params)
        .then((data) => {
          this.data.pie = data;
        })
        .complete(() => (this.loading.pie = false));
    },
    getBarData(params) {
      this.loading.bar = true;
      getAdsRankDistribution(params)
        .then((data) => {
          this.data.bar = data;
        })
        .complete(() => (this.loading.bar = false));
    },
  },
};
</script>

<style scoped></style>
